import {
  BROADCAST_QUEUE_SOURCE_DISCONNECT,
  BROADCAST_CANCEL_SOURCE_DISCONNECT,
  BROADCAST_DISCONNECT_SOURCE
} from 'actions/Types';

//This is hashmap w/ sourceId: timeoutId
const initialState = {};

export { initialState };

export default (state = initialState, action) => {
  const { payload, type } = action;

  if (type === BROADCAST_DISCONNECT_SOURCE) {
    const next = { ...state };

    next[payload.sourceId] = payload.timeoutId;

    return next;
  }

  if (type === BROADCAST_QUEUE_SOURCE_DISCONNECT) {
    return { ...state, [payload.sourceId]: payload.timeoutId };
  }

  if (type === BROADCAST_CANCEL_SOURCE_DISCONNECT) {
    const timeoutId = state[payload.sourceId];

    clearTimeout(timeoutId);

    const next = { ...state };

    delete next[payload.sourceId];

    return next;
  }

  return state;
};
